"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
var _isNaN2 = _interopRequireDefault(require("lodash/isNaN"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// JSON CONFIG _______________________________________________________
//
// "renderAs": {
//     "type": "ProgressBar",
//         "class": "html",
//             "settings": {
//         "flowProgress": "flowProgressList",
//             "middleRange": {
//             "max": 99,
//                 "min": 1
//         }
//     }
// }
var _default = exports["default"] = function _default(settings, callbackHandler) {
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row;
    var completionArr = [];
    var flowProgressList = row.flowProgressList;
    var processArr = function processArr(arr) {
      var sum = 0;
      arr.forEach(function (item) {
        if (item != null) {
          sum += +item;
        }
      });
      sum = sum / arr.length * 100;
      return sum;
    };
    var handleNil = function handleNil(score) {
      if ((0, _isNaN2["default"])(score) || !score) {
        return 0;
      }
      return score;
    };
    var handleColor = function handleColor(range, score) {
      var name = 'progress-bar';
      var color = '';
      if (score < range.max && score > range.min) {
        name += ' progress-bar-warning';
        color = '#f0ad4e';
      } else if (score > range.max) {
        name += ' progress-bar-success';
        color = '#5cb85c';
      } else {
        name += ' progress-bar-danger';
        color = '#d9534f';
      }
      return {
        name: name,
        color: color
      };
    };
    var roundHundreth = function roundHundreth(x) {
      if (x !== 100) {
        if (x === 0) {
          return x;
        }
        return Number.parseFloat(x).toPrecision(2);
      }
      return x;
    };
    flowProgressList.forEach(function (item) {
      if (item.completed) {
        completionArr.push(1);
      } else {
        completionArr.push(0);
      }
    });
    var decimal = processArr(completionArr);
    var score = roundHundreth(handleNil(decimal));
    var colors = handleColor(settings.middleRange, score);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].cell
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-center",
      style: {
        color: colors.color,
        marginBottom: '5px',
        fontWeight: 'bold',
        fontSize: '18px'
      }
    }, score, "%"), /*#__PURE__*/_react["default"].createElement("div", {
      className: "progress"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: colors.name,
      role: "progressbar",
      "aria-valuenow": "60",
      "aria-valuemin": "0",
      "aria-valuemax": "100",
      style: {
        width: "".concat(score, "%")
      }
    })));
  };
};